module.exports = __webpack_public_path__ + "static/media/delete.0a77301b.svg";